import { NavMarker } from 'react-rhumb';
import { AnimatedStepBody } from '../../animation/StepBodyAnimations';
import { StepTitle } from '../../views-components/StepTitle';
import { useCurrentStep } from '../../hooks/useCurrentStep';
import { Content, Footer } from 'signup-components/components/SidePanelLayout/SidePanelLayout';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { useResponsiveness } from '../../responsiveness/ResponsivenessProvider';
import { SidePanelManageCookies } from 'signup-components/components/ManageCookies/SidePanelManageCookies';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SidePanelErrorView = ({
  title,
  helperText,
  children,
  stepKey,
  navMarker,
  sidePanelFooterButton
}) => {
  const {
    currentStep
  } = useCurrentStep();
  const step = stepKey || currentStep;
  const {
    isDesktop
  } = useResponsiveness();
  if (!step) {
    return null;
  }
  const stepTitle = /*#__PURE__*/_jsx(StepTitle, {
    stepKey: step
  });
  const navMarkerName = navMarker || `${step}_VIEW`;
  return /*#__PURE__*/_jsxs(Content, {
    children: [!isDesktop && /*#__PURE__*/_jsx(SidePanelManageCookies, {
      isMobile: true
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(View, {
        blockSize: "19.4vh",
        marginBlockStart: '1400'
      }), /*#__PURE__*/_jsxs(AnimatedStepBody, {
        children: [/*#__PURE__*/_jsx(NavMarker, {
          name: navMarkerName
        }), /*#__PURE__*/_jsxs("div", {
          "data-selenium": `${step}_VIEW`,
          children: [/*#__PURE__*/_jsxs(View, {
            as: "div",
            marginBlockEnd: '600',
            children: [title || stepTitle, helperText && /*#__PURE__*/_jsx(Text, {
              as: "div",
              marginBlockEnd: '800',
              typography: "body-200",
              children: helperText
            })]
          }), children]
        })]
      })]
    }), /*#__PURE__*/_jsx(Footer, {
      children: /*#__PURE__*/_jsx(View, {
        children: sidePanelFooterButton
      })
    })]
  });
};